import axiosClient from './axiosClient';

export const TrainingsApi = {
  createTrainerFeedback: async (data) => {
    return await axiosClient.post('/api/trainerFeedback/create', data);
  },
  getTrainerFeedback: async (data) => {
    return await axiosClient.post('/api/trainerFeedback/get', data);
  },
  getTrainingList: async (data) => {
    return await axiosClient.post('/api/training/list', data);
  },
  getTrainingOverview: async (data) => {
    return await axiosClient.post('/api/training/overview', data);
  },
  getOverallAttendance: async (data) => {
    return await axiosClient.post(
      '/api/trainingAttendance/overall-attendance',
      data,
    );
  },
  getTraineeWiseAttendance: async (data) => {
    return await axiosClient.post(
      '/api/trainingAttendance/trainee-wise-attendance',
      data,
    );
  },
  getTraineeFeedback: async (data) => {
    return await axiosClient.post('/api/traineeFeedback/get', data);
  },
  createTraineeFeedback: async (data) => {
    return await axiosClient.post('/api/traineeFeedback/create', data);
  },
  getTrainingReport: async (data) => {
    return await axiosClient.post('/api/training/report', data);
  },
  markAttendance: async (data) => {
    return await axiosClient.post(
      '/api/trainingAttendance/mark-attendance',
      data,
    );
  },
  updateAttendance: async (data) => {
    return await axiosClient.post(
      '/api/trainingAttendance/mark-attendance',
      data,
    );
  },
  getTraineeFeedbackDownload: async (data) => {
    return await axiosClient.post(
      '/api/training/traineeFeedbackdownload',
      data,
    );
  },
  getDayWiseAttendance: async (data) => {
    return await axiosClient.post(
      '/api/trainingAttendance/day-wise-attendance',
      data,
    );
  },
  endTraining: async (data) => {
    return await axiosClient.post('/api/training/end', data);
  },
  createTraining: async (data) => {
    return await axiosClient.post('/api/training/create', data);
  },
  updateTraining: async (data) => {
    return await axiosClient.post('/api/training/edit', data);
  },
  deleteTraining: async (data) => {
    return await axiosClient.post('/api/training/delete', data);
  },
  getTrainingDetails: async (data) => {
    return await axiosClient.post('/api/training/get', data);
  },
  getcalendarList: async (data) => {
    return await axiosClient.post('/api/training/calendar', data);
  },
};
